import { call, put, takeEvery } from "redux-saga/effects"
import { GET_MAIN_PRIVILLAGE, GET_PAGE_ACTION } from "./actionTypes"
import {
  getMainPrivillageSuccess,
  getMainPrivillageFail,
  getPageActionSuccess,
  getPageActionFail,
} from "./actions"

import {
  getPageActionPrivilege,
  getUserMainMenuPrivillage,
} from "../../helpers/backend_helper"

function* onGetMainMenuPrivillage(params) {
  try {
    const response = yield call(getUserMainMenuPrivillage, params.payload)
    yield put(getMainPrivillageSuccess(response))
  } catch (err) {
    yield put(getMainPrivillageFail(err))
  }
}

function* onGetPageAction(params) {
  try {
    const response = yield call(getPageActionPrivilege, params.payload)
    yield put(getPageActionSuccess(response))
  } catch (err) {
    yield put(getPageActionFail(err))
  }
}
function* privillageSaga() {
  yield takeEvery(GET_MAIN_PRIVILLAGE, onGetMainMenuPrivillage)
  yield takeEvery(GET_PAGE_ACTION, onGetPageAction)
}

export default privillageSaga
